import React, { Component } from 'react';

import ExperimentContainer from 'common/containers/ExperimentContainer';
import ModalContainer from 'common/containers/ModalContainer';
import RouterContainer from 'common/containers/RouterContainer';
import ViewerContainer from 'common/containers/ViewerContainer';
import Helmet from 'common/helmets/Helmet';

import JobsNav from './JobsNav';
import { loadJobs } from '../actions/jobs';
import asyncConnect from '../core/asyncConnect';
import cloneElementWithProps from '../core/cloneElementWithProps';

import 'css/components/jobs/_JobsContainer.scss';

class JobsContainer extends Component {
  render() {
    const { children, jobs } = this.props;
    return (
      <RouterContainer
        location={this.props.location}
        params={this.props.params}
        route={this.props.route}
        router={this.props.router}>
        <div className="jobsContainer">
          <Helmet defaultIcons title="Jobs | Canny" />
          <JobsNav />
          <div className="mainContainer">
            <ModalContainer>
              <ViewerContainer>
                <ExperimentContainer>
                  {cloneElementWithProps(children, {
                    ...this.props,
                    jobs: (jobs && jobs.jobs) || [],
                  })}
                </ExperimentContainer>
              </ViewerContainer>
            </ModalContainer>
          </div>
        </div>
      </RouterContainer>
    );
  }
}

export default asyncConnect(
  [
    ViewerContainer.asyncConnect,
    {
      promise: ({ store: { dispatch } }) => {
        return dispatch(loadJobs());
      },
    },
  ],
  (state) => ({ jobs: state.jobs }),
)(JobsContainer);
